module.exports = "https://coursera_assets.s3.amazonaws.com/images/ab1349e5207c4c125568bb219a50c1da.svg";